import { MaskedInput } from 'components/Inputs/MaskedInput';
import { TextInput } from 'components/Inputs/TextInput';
import React, { useEffect } from 'react';
import {
  creditCardExpiresValidator,
  requiredMessage,
} from 'schemas/validators';

import { Grid } from '@mui/material';

import { CouponInput } from './CouponInput';
import { CreditCardFlag } from 'components/atoms/CreditCardFlag';
import { useFormContext } from 'react-hook-form';
import { CPFInput } from 'components/Inputs';

interface Props {
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  disabled?: boolean;
}

export const TutorCreditCardForm: React.FC<Props> = ({
  disabled,
  inputRef,
}) => {
  const { watch, setValue } = useFormContext();

  const cardNumber = watch('creditCard.number');

  useEffect(() => {
    setValue('creditCard.token', '');
  }, [cardNumber, setValue]);

  return (
    <Grid container item spacing={2}>
      <Grid item xs={12} md={6}>
        <TextInput
          name="creditCard.name"
          id="creditCard.name"
          label="NOME DO TITULAR DO CARTÃO"
          required
          rules={{
            required: requiredMessage('Nome do Titular do Cartão'),
          }}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <CPFInput
          rules={{required: requiredMessage('CPF')}}
          id="creditCard.cpf"
          name="creditCard.cpf"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MaskedInput
          id="creditCard.number"
          name="creditCard.number"
          label="NÚMERO DO CARTÃO"
          mask="#### #### #### #### ###"
          required
          rules={{
            required: requiredMessage('Número do Cartão'),
            minLength: { value: 14, message: 'Número do cartão inválido' },
          }}
          inputProps={{
            className: 'pjbank-cartao',
          }}
          disabled={disabled}
          InputProps={{
            endAdornment: <CreditCardFlag cardNumber={cardNumber} />,
          }}
        />

        <input hidden className="pjbank-token" ref={inputRef} />
      </Grid>

      <Grid item xs={12} md={3}>
        <MaskedInput
          id="creditCard.expires"
          name="creditCard.expires"
          label="DATA DE VENCIMENTO"
          mask="##/####"
          placeholder="05/2028"
          required
          rules={{
            required: requiredMessage('Data de Vencimento'),
            validate: creditCardExpiresValidator,
          }}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <MaskedInput
          name="creditCard.cvv"
          id="creditCard.cvv"
          label="CVV"
          mask="####"
          required
          rules={{
            required: requiredMessage('CVV'),
            minLength: { value: 3, message: 'CVV inválido' },
          }}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={5}>
        <CouponInput disabled={disabled} />
      </Grid>
    </Grid>
  );
};
